import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseDropdownComponent),
    multi: true
};


//interfaces
import { IDropdown } from '../interfaces/IDropdown.interface';


export abstract class BaseDropdownComponent implements OnInit, IDropdown{


     //The internal data model
     private innerValue: any = '';
     
     //Placeholders for the callbacks which are later providesd
     //by the Control Value Accessor
     private onTouchedCallback: () => void = noop;
     private onChangeCallback: (_: any) => void = noop;
 
     //get accessor
     get value(): any {
         return this.innerValue;
     };
 
     //set accessor including call the onchange callback
     set value(v: any) {
         if (v !== this.innerValue) {
             this.innerValue = v;
             this.valueChange.emit(v);
             this.onChangeCallback(v);
         }
     }
 
     //Set touched on blur
     onBlur() {
         this.onTouchedCallback();
     }
 
     //From ControlValueAccessor interface
     writeValue(value: any) {
         if (value !== this.innerValue) {
             this.innerValue = value;
         }
     }
 
     //From ControlValueAccessor interface
     registerOnChange(fn: any) {
         this.onChangeCallback = fn;
     }
 
     //From ControlValueAccessor interface
     registerOnTouched(fn: any) {
         this.onTouchedCallback = fn;
     }
     
     load(){};
     ngOnInit() {};
     
     @Input() public selectedID: number;
     @Output() public valueChange: EventEmitter<number> = new EventEmitter();
     @Output() public loadDone: EventEmitter<any> = new EventEmitter();
     @Input() public selectDefault: boolean;
     @Input() public disabled: boolean;
     
     @Input() public selectItems: SelectItem[] = [];

     onFocus(event: any) {
        //console.info("onFocus: eventPhase: " + event.eventPhase + " value=" + this.value + " selectedID: " + this.selectedID);
        if (this.selectedID){
            if (!this.value){
                this.value = this.selectedID;
                //console.info("onFocus: changed this.value to " + this.selectedID);
            }
        }
    }

}

export default BaseDropdownComponent;